// import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		type: 'list',
		addParams: {},
		money: 0,
		activityMoney: 0,
		remark: '',
		curDiscountCard: null,
		refresh: 1,
		pet_buy_item:'2',
	},
	getters: {

	},
	mutations: {
		set_type(state, params) {
			state.type = params;
		},
		set_addParams(state, obj) {
			state.addParams = obj;
		},
		set_pet_buy_item(state, obj) {
			state.pet_buy_item = obj;
		},
		
		set_money(state, params) {
			state.money = params;
		},
		set_activityMoney(state, params) {
			state.activityMoney = params;
		},
		set_remark(state, obj) {
			state.remark = obj;
		},
		set_curDiscountCard(state, obj) {
			state.curDiscountCard = obj;
		},
		set_refresh(state) {
			state.refresh = state.refresh + 1;
		},
	},
	actions: {

	},
};
